import React, {useState} from 'react';

import {nowISOString} from '../../../utils/dateFunctions';


export default function ReadingAdd({authFetch, origType, userId}) {
    const nowISO = nowISOString();
    const [dateTime, setDateTime] = useState(nowISO);
    const [activeAmount, setActiveAmount] = useState('');
    const [note, setNote] = useState('');

    const handleSubmit = async e => {
        e.preventDefault();

        const info = {
            typeId: origType._id,
            activeAmount,
            dateTime,
            note,
            userId,
        };

        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/reading/add`, {
                method: 'POST',
                body: JSON.stringify(info),
            });

            if (!response.ok) {
                console.error('Failed to create reading:', await response.text());
                alert('Error creating reading');
                return;
            }

            window.location.href = '/type/' + origType._id;
        } catch (err) {
            console.error('Failed to create reading:', err);
            alert('Error creating reading');
        }
    };

    return (
        <>
            <h2>Add {origType.name} Reading</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <p>{origType.name} Amount ({origType.activeUnits})</p>
                    <input type="number" value={activeAmount} onChange={e => setActiveAmount(e.target.value)}/>
                </label>
                <label>
                    <p>Date/Time</p>
                    <input type="text" value={dateTime} onChange={e => setDateTime(e.target.value)}/>
                </label>
                <label>
                    <p>Notes (optional)</p>
                    <input type="text" value={note} onChange={e => setNote(e.target.value)}/>
                </label>
                <div>
                    <button type="submit">Create</button>
                </div>
            </form>
        </>
    );
}